import React from 'react';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { AutoAwesomeRounded as SynthesisIcon } from '@mui/icons-material';
import colors from '../../assets/theme/colors';

const JourneySynthesisPanel = ({ synthesis, accent, onOpenReferences }) => {
  const sections = (synthesis?.sections || []).filter((section) => section.statements?.length);
  if (!sections.length) return null;

  return (
    <Box sx={{ m: 1, p: 1.5, borderRadius: '20px', bgcolor: alpha(accent.primary, 0.045), border: `1px solid ${alpha(accent.primary, 0.14)}` }}>
      <Stack direction="row" spacing={0.8} alignItems="center">
        <SynthesisIcon sx={{ fontSize: 19, color: accent.ink }} />
        <Typography sx={{ fontSize: '0.92rem', fontWeight: 750, color: colors.semantic.ink }}>
          What may matter for this meeting
        </Typography>
      </Stack>
      <Stack spacing={1.35} sx={{ mt: 1.2 }}>
        {sections.map((section) => (
          <Box key={section.id}>
            <Typography sx={{ mb: 0.45, fontSize: '0.75rem', fontWeight: 750, color: alpha(colors.semantic.ink, 0.62) }}>
              {section.label}
            </Typography>
            <Stack component="ul" spacing={0.6} sx={{ m: 0, pl: 2.2 }}>
              {section.statements.map((statement) => (
                <Box component="li" key={statement.id} sx={{ color: colors.semantic.ink }}>
                  <Stack direction="row" spacing={0.55} alignItems="flex-start">
                    <Typography sx={{ flex: 1, fontSize: '0.87rem', lineHeight: 1.43, color: alpha(colors.semantic.ink, 0.84) }}>
                      {statement.text}
                    </Typography>
                    <ButtonBase
                      onClick={() => onOpenReferences(statement.sourceIds)}
                      aria-label={`View ${statement.sourceIds.length} supporting source${statement.sourceIds.length === 1 ? '' : 's'}`}
                      sx={{ flexShrink: 0, px: 0.45, py: 0.15, borderRadius: '6px', color: accent.ink, bgcolor: alpha(accent.primary, 0.1), fontSize: '0.7rem', fontWeight: 750 }}
                    >
                      [{statement.sourceIds.length === 1 ? '1' : `1–${statement.sourceIds.length}`}]
                    </ButtonBase>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default JourneySynthesisPanel;
